import { render, staticRenderFns } from "./Vacaciones.vue?vue&type=template&id=ed8e8f30&scoped=true&"
import script from "./Vacaciones.vue?vue&type=script&lang=js&"
export * from "./Vacaciones.vue?vue&type=script&lang=js&"
import style0 from "./Vacaciones.vue?vue&type=style&index=0&id=ed8e8f30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8e8f30",
  null
  
)

export default component.exports